export default __webpack_public_path__ + "static/media/im-placeholderBig.9770a245.svg";